const styles = {
  verticalAlign: 'middle',
  overflow: 'visible',
  marginTop: 'calc(var(--ci-size, 1.1em) / -5)',
  height: '1em',
  width: 'var(--ci-size, 1.1em)',
  strokeWidth: 'var(--ci-stroke, 2px)',
};

export default styles;
